import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { useCountdown } from '../contexts/CountdownContext';
export function StickyBuyBar() {
  const {
    label
  } = useCountdown();
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const offer = document.getElementById('offer');
    const observer = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.15
    });
    if (offer) observer.observe(offer);
    return () => {
      window.removeEventListener('scroll', onScroll);
      observer.disconnect();
    };
  }, []);
  const show = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-260" data-mp="1w20zla5i1cbf">
      {show && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 backdrop-blur" data-id="element-261" data-mp="1w32bthy944uq">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-4 px-4 py-3" data-id="element-262" data-mp="2iduusv610cmi">
            <div className="min-w-0" data-id="element-263" data-mp="2n7p7hen7rrc3">
              <p className="truncate font-display text-base font-bold text-ink md:text-lg" data-id="element-264" data-mp="2s57j5csm8kns">Maker Lab™ + 3 bonuses</p>
              <p className="text-sm font-bold text-inkSoft" data-id="element-265" data-mp="2x3slbhrfheev">
                <span className="line-through" data-id="element-266" data-mp="2x6eqxburdjug">$113</span> <span className="font-display text-lg text-teal" data-id="element-267" data-mp="322vd40iedo4w">$27</span>
                <span className="ml-2 hidden tabular-nums sm:inline" data-id="element-268" data-mp="36505yx10ugqh">· ends in {label}</span>
              </p>
            </div>
            <CTAButton size="md" data-id="element-269" data-mp="17q5mpsr8mx29">
              <span className="sm:hidden" data-id="element-270" data-mp="17qyn8bzlsqby">Get access</span>
              <span className="hidden sm:inline" data-id="element-271" data-mp="1bqftv8qrntip">Get instant access</span>
            </CTAButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}